/**
 * Finishing fee added to every published variant. Published price = catalog Sizes.UnitPrice
 * (+ profit + extra-location charge); there is NO implicit finishing fee. A store's own
 * FinishingPrice is honored when set (0 included), otherwise 0.
 * Constants.finishingCost (2.50) is the sizing-label charge and must not be used here.
 */
export function resolvePublishFinishingCost(store: any): number {
  const value = store?.FinishingPrice ?? store?.FinshingPrice;
  const n = Number(value);
  return value === null || value === undefined || isNaN(n) ? 0 : n;
}
